import { render } from "./avatar-dropdown.vue?vue&type=template&id=7c017c8d"
import script from "./avatar-dropdown.vue?vue&type=script&lang=ts"
export * from "./avatar-dropdown.vue?vue&type=script&lang=ts"

import "./avatar-dropdown.vue?vue&type=style&index=0&id=7c017c8d&lang=less"
script.render = render

export default script